module.exports = __webpack_public_path__ + "static/media/packing-unpacking.cd7b0402.png";